import { apiClient } from '../client';

export interface UserFilter {
  all?: boolean;
  universities?: string[];
  campuses?: string[];
  hobbies?: string[];
  userRoles?: string[];
  search?: string;
  selectedUserIds?: string[];
}

export interface MessagePreview {
  recipientCount: number;
  filterDescription: string;
  filters: UserFilter;
}

export interface AdminMessage {
  _id: string;
  message: string;
  links?: string[];
  sentBy: string;
  sentByName: string;
  recipientCount: number;
  status: 'pending' | 'sent' | 'failed';
  sentAt: Date;
  createdAt: Date;
}

export interface SendMessageRequest {
  message: string;
  links?: string[];
  filters: UserFilter;
  confirmText: string;
}

export interface RemoveUserRequest {
  reason: string;
  sendEmail: boolean;
}

export const adminAPI = {
  filterUsers: async (filters: UserFilter) => {
    const response = await apiClient.post('/api/admin/users/filter', filters);
    return response.data;
  },

  previewMessageRecipients: async (filters: UserFilter): Promise<MessagePreview> => {
    const response = await apiClient.post('/api/admin/message/preview', filters);
    return response.data;
  },

  sendAdminMessage: async (data: SendMessageRequest) => {
    const response = await apiClient.post('/api/admin/message/send', data);
    return response.data;
  },

  getAdminMessages: async (params: { page?: number; limit?: number } = {}) => {
    const response = await apiClient.get('/api/admin/messages', {
      params: { page: params.page || 1, limit: params.limit || 20 }
    });
    return response.data;
  },

  removeUser: async (userId: string, data: RemoveUserRequest) => {
    const response = await apiClient.delete(`/api/admin/users/${userId}/remove`, {
      data
    });
    return response.data;
  }
};

export const getAdminMessages = adminAPI.getAdminMessages;